export const ALERT_SUCCESS = 'ALERT_SUCCESS';
export const ALERT_ERROR = 'ALERT_ERROR';
export const ALERT_WARNING = 'ALERT_WARNING';
export const ALERT_INFO = 'ALERT_INFO';
export const CLOSE = 'CLOSE';

export const success = message => dispatch =>
  dispatch({
    type: ALERT_SUCCESS,
    message,
    variant: 'success'
  });

export const error = message => dispatch =>
  dispatch({
    type: ALERT_ERROR,
    message: message || 'Request error',
    variant: 'error'
  });

export const warning = message => dispatch =>
  dispatch({
    type: ALERT_WARNING,
    message,
    variant: 'warning'
  });

export const info = message => dispatch =>
  dispatch({
    type: ALERT_INFO,
    message,
    variant: 'info'
  });

export const close = () => dispatch =>
  dispatch({
    type: CLOSE
  });
